import { takeEvery } from 'redux-saga/effects';
import { load } from 'sdk/scheduledTransaction';
import { LOAD, LOAD_MODEL_ID } from 'model/scheduledTransaction';
import { callAction, ORM } from '../util';
import { LOAD_ID } from '../model/scheduledTransaction';
import { loadById } from '../sdk/scheduledTransaction';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(
    LOAD_ID.ACTION,
    callAction({ api: loadById, dataName: ORM, type: LOAD_ID })
  );

  yield takeEvery(
    LOAD_MODEL_ID.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD_MODEL_ID,
    })
  );
}
